module.exports = __webpack_public_path__ + "static/media/Footer_Adornment_2.0e8f0514.png";